import React from "react";

import './styles.css';

import HideTextInput from '../../TextInput/HideTextInput';

import LinearLoader from "../../Loader/LinearLoader";

function ResetPasswordForm({
    password, setPassword, passwordWarning,
    confirmPassword, setConfirmPassword, confirmPasswordWarning,
    onClick, nav, loading
}) {

    return(
        <form className="forgot-password-container">
                <h1>Redefinir senha</h1>
                <div className="forgot-password-card">
                    <div className="forgot-password-form-container">
                        <p className="forgot-password-form-title">Nova senha</p>
                        <p className="forgot-password-form-subtitle">Qualquer dúvida, fale com nosso <span className="create-account" onClick={nav}>suporte</span></p>
                            <div className="forgot-password-form-inputs-container">
                                <HideTextInput
                                    label="Nova senha"
                                    value={password}
                                    setValue={setPassword}
                                    warningMessage={passwordWarning}
                                />
                                <HideTextInput
                                    label="Confirme sua nova senha"
                                    value={confirmPassword}
                                    setValue={setConfirmPassword}
                                    warningMessage={confirmPasswordWarning}
                                />
                            </div>
                            <button type="submit" className="forgot-password-form-button" onClick={onClick}>
                            {
                                loading ? <LinearLoader white /> : <p>Confirmar</p>
                            }
                            </button>
                    </div>
            </div>
        </form>
    )
}   

export default ResetPasswordForm;